import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnInvoiceTick = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="m9.64 11.52 1.428 1.428 3.81-3.81M7.662 18.77c.675-.773 1.705-.712 2.299.132l.832 1.188c.667.94 1.747.94 2.414 0l.832-1.188c.594-.844 1.624-.905 2.3-.132 1.466 1.671 2.66 1.117 2.66-1.222v-9.91c.01-3.545-.765-4.433-3.88-4.433h-6.23C5.775 3.205 5 4.093 5 7.637v9.902c0 2.348 1.203 2.894 2.662 1.231"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnInvoiceTick;
